import { render, staticRenderFns } from "./MidiaNomear.vue?vue&type=template&id=01b4bea0&scoped=true"
import script from "./MidiaNomear.vue?vue&type=script&lang=js"
export * from "./MidiaNomear.vue?vue&type=script&lang=js"
import style0 from "./MidiaNomear.vue?vue&type=style&index=0&id=01b4bea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4bea0",
  null
  
)

export default component.exports